// Gate 1 item F: the load the placeholder art must put on the phone, as if it
// were final art. ONE place for these numbers. After graded runs start
// (Mon 2026-10-12) they must not change: the protocol forbids lowering the
// load. load.config.test.js pins every value, and every run log records them.
export const LOAD = Object.freeze({
    // Render at the phone's native resolution (devicePixelRatio, no downscaling).
    nativeResolution: true,
    // Textures are drawn at this multiple of their on-screen size in device pixels.
    textureScale: 2,
    // Structure textures (structures, Broods, eggs, rockets, drones), px square.
    structureTexturePx: 256,
    // Largest atlas, px square. Every texture is packed into atlases of at most this size.
    atlasMaxPx: 2048,
    // On screen: every cell of both Hives (630), plus all structures, craters
    // and stamps of the item B scene. Item B's minimums:
    minCraters: 3,
    minStamps: 10,
    // Reveal beat (item C): clash -> crater effect particles at peak, additive.
    craterParticlesPeak: 400,
    craterParticleBlend: 'add',
    // Missile: one sprite plus a trail of this many particles.
    missileTrailParticles: 60,
    // Particles are ordinary Sprites, not ParticleContainer (approved 2026-10-06).
    particleContainer: false,

    // Raised 2026-10-07 to match the real war screen, not a best case.
    // Structures: at most 9 per Hive in play, so 18 on screen. A graded scene
    // with fewer is topped up to 9 per Hive in a marked step (scene/augment.js).
    structuresPerHive: 9,
    structuresOnScreen: 18,
    // A library of distinct 256x256 structure textures: 50 structures x 3
    // milestone levels = 150, packed 64 per 2048 atlas (no padding) = 3
    // atlases, all uploaded to the GPU at load. The 18 on-screen structures
    // use distinct textures drawn from all 3 atlases.
    structureLibraryStructures: 50,
    structureLibraryLevels: 3,
    // Distinct cell terrain textures, mixed across the 630 cells.
    cellTerrainVariants: 8,
    // A full-screen background sprite at native resolution, under the Hives.
    backgroundFullScreen: true,
    // HUD drawn in PixiJS: icon/button sprites and live text objects; every
    // text changes once per hudTextUpdateMs (beat included).
    hudIcons: 20,
    hudTexts: 40,
    hudTextUpdateMs: 1000,
    // How HUD text is drawn (decided 2026-10-07): bitmap text from a glyph
    // atlas made once at load, so a text change re-lays out quads with no
    // canvas re-draw or GPU upload. Canvas text (one texture per text,
    // re-uploaded on change) gave the iPhone an 80-90 ms hold every second.
    hudTextMethod: 'bitmap',
    hudGlyphs: '0-9 A-Z a-z, space and : / · + - .',
})

// On-screen size of each sprite kind, in hex radii (R): the scene is laid out
// in board units where a hex cell is 2R wide and sqrt(3)R tall.
export const ON_SCREEN_R = Object.freeze({
    cell: { w: 2, h: Math.sqrt(3) },
    structure: { w: 1.5, h: 1.5 },
    brood: { w: 1.6, h: 1.6 },
    egg: { w: 0.9, h: 0.9 },
    rocket: { w: 1.1, h: 1.1 },
    drone: { w: 3.6, h: 3.6 },  // the lab's drone disc: radius 1.8R
    stamp: { w: 1.8, h: 0.9 },
    missile: { w: 4.2, h: 4.2 },  // 3x (was 1.4) so it reads on a phone
    particle: { w: 0.45, h: 0.45 },
    icon: { w: 1.9, h: 1.9 },
})
